<template>
  <div class="container shadow">
    <div class="card">
      <div class="card-body">
        <!-- <p class="text-dark"> {{$store.state.role}}</p> -->
        <ul class="nav nav-pills nav-pills-primary nav-justified">
          <li class="nav-item mr-4">
            <a
              href=""
              data-target="#manage"
              data-toggle="pill"
              class="btn p-4 btn-dark nav-link active show "
            >
              <span class="hidden-xs"><b>Contacts</b></span></a
            >

            <small class="m-1"
              >In this section you can edit or delete a blog
            </small>
            <small class="m-1"><b>Total Contacts: </b></small>
            <span class="badge badge-pill badge-info m-1">{{
              contacts.length
            }}</span>
          </li>

          <li class="nav-item mr-4">
            <a
              data-target="#create"
              data-toggle="pill"
              class="btn p-4 btn-dark nav-link"
            >
              <span class="hidden-xs"><b>Send an Invoice</b></span></a
            >=
            <!-- <small class="m-1"> is gonna display in the home page </small>  -->
          </li>

          <!-- <li class="nav-item bg-dark p-2 card shadow text-white"> -->
          <li class="nav-item mr-4">
            <a
              href=""
              data-target="#assign"
              data-toggle="pill"
              class="btn p-4 btn-dark nav-link"
            >
              <span class="hidden-xs">Nothing for now</span></a
            >
          </li>
        </ul>

        <div class="tab-content p-3">
          <div class="tab-pane" id="create">
            <send-invoice></send-invoice>
          </div>

          <div class="tab-pane active show" id="manage">
            <v-simple-table dark>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Name</th>
                    <th class="text-left">Business Name</th>
                    <th class="text-left">Point of Contact</th>
                    <th class="text-left">Industry</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="contact in contacts" :key="contact.id">
                    <td>{{ contact.name }}</td>
                    <td>{{ contact.business_name }}</td>
                    <td>{{ contact.point_of_contact }}</td>
                    <td>{{ contact.industry }}</td>

                    <td>
                      <a
                        href="#"
                        @click="openProfile(contact)"
                        style="color: white"
                        class="btn btn-info btn-sm ml-2"
                      >
                        Open Profile
                      </a>
                      <form @submit.prevent="">
                        <v-btn
                          color="#E53935"
                          class="text-white"
                          type="submit"
                          small
                          @click="archive(contact)"
                          >Archive</v-btn
                        >
                      </form>

                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <div class="tab-pane" id="assign"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contacts: []
    };
  },

  created() {
    this.getContacts();
  },

  methods: {
    getContacts(){
      window.axios.get("api/contact").then(response => {
        this.contacts = response.data;
      })
    },

    openProfile(contact) {
      this.$router.push({ name: "Contact", params: { id: contact.id } });
    },

    archive(contact) {
      window.axios.delete("api/archive/" + contact.id).then(() => {
        this.$swal('Success!', 'This user has been soft deleted.'),
        this.getContacts()
      });
    }

  }
};
</script>
<style scoped>
.classActive {
  background-color: rgb(15, 15, 15);
  border: 0;
}
</style>
